<template>
  <v-card>
    <v-card-title class="error white--text headline">
      <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
      {{ $t('importErrors') }}
      <v-spacer/>
      <BaseDialogActions hideRefresh @close="$emit('close')">
        <template v-slot:left>
          <Icon
            icon="mdi-download"
            iconColor="white"
            :tooltipText="$t('downloadErrors')"
            :small="false"
            @icon-clicked="downloadErrors"
          />
        </template>
      </BaseDialogActions>
    </v-card-title>
    <v-card-text class="pt-4">
      <v-row dense>
        <v-col cols="12" class="mb-2">
          <span class="subtitle-1">{{ $t('importErrorsDescription', { count: errors.length }) }}</span>
        </v-col>
        <v-col cols="12">
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(group, index) in groupedErrors" :key="index">
              <v-expansion-panel-header :style="{ height: $vuetify.breakpoint.xl ? '48px' : $vuetify.breakpoint.mdAndUp ? '64px' : $vuetify.breakpoint.smAndUp ? '100px' : '200px' }">
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <span class="font-weight-medium">{{ $t('ticketNumber') }}: {{ group.ticketNumber }}</span>
                  </v-col>
                  <v-col>
                    <span class="grey--text ml-2 caption">({{ group.messages.length }} {{ group.messages.length === 1 ? $t('error') : $t('errors') }})</span>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list dense>
                  <v-list-item v-for="(msg, i) in group.messages" :key="i">
                    <v-list-item-icon class="mr-2 my-auto">
                      <span class="font-weight-light">{{ i + 1 }}.</span>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <span class="body-2">{{ msg }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ImportErrorsDialog',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    errors: {
      type: Array,
      required: true
    },
    fileName: {
      type: String,
      default: 'import'
    }
  },

  computed: {
    groupedErrors () {
      const map = new Map()
      for (const e of this.errors) {
        const key = e.ticketNumber ?? 'N/A'
        if (!map.has(key)) map.set(key, [])
        map.get(key).push(...this.messagesFor(e))
      }
      return Array.from(map.entries()).map(([ticketNumber, messages]) => ({ ticketNumber, messages }))
    }
  },

  methods: {
    messagesFor (e) {
      return Array.isArray(e.messages) ? e.messages : [e.messages ?? e.message ?? 'Unknown error']
    },

    downloadErrors () {
      const baseName = this.fileName.includes('.') ? this.fileName.split('.').slice(0, -1).join('') : this.fileName
      const header = `${this.$t('ticketNumber')},${this.$t('message')}`
      const rows = this.errors.map(e => `"${e.ticketNumber ?? 'N/A'}","${this.messagesFor(e).join('; ').replace(/"/g, '""')}"`)
      const csv = [header, ...rows].join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `Import_Errors_${moment().format('YYYYMMDD_HHmmss')}_${baseName}.csv`
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>
